import { Component, Input } from '@angular/core';
import { TreeviewBase } from './../treeview.base';
import { TreeViewGroupedData } from '../../models/tree-view-grouped-data';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap/nav';
import { CheckboxTreeviewComponent } from '../checkbox-treeview/checkbox-treeview.component';

@Component({
    selector: 'treeview-grouped',
    templateUrl: './treeview-grouped.component.html',
    imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, CheckboxTreeviewComponent, NgbNavOutlet, TranslatePipe]
})
export class TreeviewGroupedComponent extends TreeviewBase {

    @Input() declare treeViewData: TreeViewGroupedData;
    @Input() showFilter?: boolean = false;
    @Input() maxHeight?: number = 350;
    @Input() activeTab?: number = 0;

    constructor() { super(); }

    /**
     * Tab-byte. Rita om TreeView med aktuella data.
     * @param $event
     */
    public beforeChange() {
        this.treeViewData.setItems(this.paramData);
    };

}
